import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    canvas: {
        width: '300px',
        height: '350px',
    },
}));
